// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const HELIX_CRQS_ACTIONS = {

	// ── Creations: Get CRQs to Create ─────────────────────────────────────────
	HC_GET_CRQS_TO_CREATE_REQUEST: 'HC_GET_CRQS_TO_CREATE_REQUEST',
	HC_GET_CRQS_TO_CREATE_SUCCESS: 'HC_GET_CRQS_TO_CREATE_SUCCESS',
	HC_GET_CRQS_TO_CREATE_FAILURE: 'HC_GET_CRQS_TO_CREATE_FAILURE',

	// ── Creations: Get CRQs on Queue with Error ───────────────────────────────
	HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST: 'HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST',
	HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS: 'HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS',
	HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE: 'HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE',

	// ── Creations: CRQs to Create Action ──────────────────────────────────────
	HC_CRQS_TO_CREATE_ACTION_REQUEST: 'HC_CRQS_TO_CREATE_ACTION_REQUEST',
	HC_CRQS_TO_CREATE_ACTION_SUCCESS: 'HC_CRQS_TO_CREATE_ACTION_SUCCESS',
	HC_CRQS_TO_CREATE_ACTION_FAILURE: 'HC_CRQS_TO_CREATE_ACTION_FAILURE',

	// ── Creations: CRQs on Queue with Error Action ────────────────────────────
	HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST: 'HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST',
	HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS: 'HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS',
	HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE: 'HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE',

};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Creations: Get CRQs to Create
export const hcGetCrqsToCreateRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_REQUEST });
export const hcGetCrqsToCreateSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_SUCCESS, payload });
export const hcGetCrqsToCreateFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_FAILURE, error });

// Creations: Get CRQs on Queue with Error
export const hcGetCrqsOnQueueWithErrorRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST });
export const hcGetCrqsOnQueueWithErrorSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS, payload });
export const hcGetCrqsOnQueueWithErrorFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE, error });

// Creations: CRQs to Create Action
export const hcCrqsToCreateActionRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_REQUEST });
export const hcCrqsToCreateActionSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_SUCCESS, payload });
export const hcCrqsToCreateActionFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_FAILURE, error });

// Creations: CRQs on Queue with Error Action
export const hcCrqsOnQueueWithErrorActionRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST });
export const hcCrqsOnQueueWithErrorActionSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS, payload });
export const hcCrqsOnQueueWithErrorActionFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE, error });